module.exports = __webpack_public_path__ + "92d59a019dd7fa59bd537b1f7399e5aa.png";